<lxm-dialog [dialogRef]="dialogRef" [formGroup]="formGroup" #dialog>
  <span header-title>
    {{'cards.products.product_pricelist.expiration_dialog.title' | translate}}
  </span>
  <div body>
    <display-product [data]="product" class="mt20 mb20"></display-product>
    <form-field
      label="cards.products.product_pricelist.expiration_dialog.label.scheme_type"
    >
      <div any class="nowrap flex flex-row align-center gap-1">
        <type-indicator
          [typeId]="schemeType"
          enum="ProductPriceSchemeType"
        ></type-indicator>
        {{schemeType | translateEnum : "ProductPriceSchemeType" }}
      </div>
    </form-field>

    <form-field
      label="cards.products.product_pricelist.expiration_dialog.label.valid"
    >
      <div any class="align-center flex flex-row">
        <lxm-datepicker for="validFrom" [disabled]="true"></lxm-datepicker>
        <span class="date-range__separator"> - </span>
        <lxm-datepicker for="validTo" [min]="minValidTo"></lxm-datepicker>
      </div>
    </form-field>

    <card-message type="error" *ngIf="formGroup.errors?.validTo">
      {{formGroup.errors?.validTo[0]?.value | translate}}
    </card-message>
  </div>

  <section footer>
    <lxm-button
      type="orange"
      label="action.save"
      [loading]="actionLoading.save"
      (click)="save()"
      buttonType="submit"
    >
    </lxm-button>
    <lxm-button
      type="grey"
      label="action.cancel"
      (click)="closeDialog()"
    ></lxm-button>
  </section>
</lxm-dialog>
